import { useState, useEffect, RefObject } from 'react';

/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

/**
 *
 * @param ref is a useRef element
 * @param options is an object of a type IIntersectionObserverOptions that IntersectionObserver consumes for self configuration.
 * @returns boolean value "isOnViewport"
 */
export interface IIntersectionObserverOptions {
  root: any;
  rootMargin: string;
  threshold: [number, number] | number;
}

const useIsOnViewportObserver = (ref: RefObject<HTMLElement>, options: IIntersectionObserverOptions) => {
  const [isOnViewport, setIsOnViewport] = useState(false);

  const callbackFunction = (entries: any) => {
    const [entry] = entries;
    setIsOnViewport(entry.isIntersecting);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref, options]);

  return isOnViewport;
};

export default useIsOnViewportObserver;
